import React from 'react'
import {Icon} from '@chakra-ui/react'

const RefreshIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M20.13 39.1554C10.136 39.1554 2 31.0195 2 21.016C2 11.0126 10.136 2.88605 20.13 2.88605C25.3663 2.88605 29.9176 4.82855 33.2771 8.51648C33.6243 8.90123 33.5961 9.49242 33.2208 9.83963C32.836 10.1868 32.2448 10.1587 31.8976 9.78333C28.9041 6.49891 24.8408 4.77224 20.1394 4.77224C11.1682 4.76286 3.87681 12.0543 3.87681 21.016C3.87681 29.9778 11.1682 37.2692 20.13 37.2692C29.0918 37.2692 36.3832 29.9778 36.3832 21.016C36.3832 20.4999 36.8055 20.0776 37.3216 20.0776C37.8377 20.0776 38.26 20.4999 38.26 21.016C38.26 31.0101 30.124 39.146 20.13 39.146V39.1554Z"
                fill="currentColor"
            />
            <path
                d="M32.7607 10.1681C32.2634 10.1681 31.8505 9.78334 31.8223 9.2766L31.4282 1.98518C31.4 1.46906 31.7942 1.02801 32.3103 0.999858C32.817 0.962322 33.2674 1.36584 33.2956 1.88196L33.6897 9.17337C33.7179 9.6895 33.3238 10.1305 32.8076 10.1587C32.7889 10.1587 32.7701 10.1587 32.7513 10.1587L32.7607 10.1681Z"
                fill="currentColor"
            />
            <path
                d="M25.5158 10.9845C25.0466 10.9845 24.6337 10.6279 24.5868 10.1493C24.5305 9.63322 24.8964 9.1734 25.4126 9.10771L32.6571 8.2913C33.1732 8.22561 33.633 8.60097 33.6987 9.11709C33.7644 9.63322 33.389 10.093 32.8729 10.1587L25.6284 10.9751C25.6284 10.9751 25.5533 10.9751 25.5252 10.9751L25.5158 10.9845Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default RefreshIcon
